import { render, staticRenderFns } from "./TrainingQuizAnswer.vue?vue&type=template&id=4e930585&"
import script from "./TrainingQuizAnswer.vue?vue&type=script&lang=js&"
export * from "./TrainingQuizAnswer.vue?vue&type=script&lang=js&"
import style0 from "./TrainingQuizAnswer.vue?vue&type=style&index=0&id=4e930585&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports